import { Fragment } from "react";
import { Container, Row } from "reactstrap";
import { Breadcrumbs } from "../../../AbstractElements";
import { Divider, UIKits } from "../../../Constants/Constants";
import AnimatedColorDivider from "./AnimatedColorDivider";
import HorizontalDashedDivider from "./HorizontalDashedDivider";
import HorizontalDottedDivider from "./HorizontalDottedDivider";
import HorizontalSolidDivider from "./HorizontalSolidDivider";
import VerticalDottedDivider from "./VerticalDottedDivider";
import VerticalDoubleDivider from "./VerticalDoubleDivider";
import VerticalSolidDivider from "./VerticalSolidDivider";
import HorizontalEditableDivider from "./HorizontalEditableDivider";
import SimpleHorizontalDivider from "./SimpleHorizontalDivider";
import SimpleVerticalDivider from "./SimpleVerticalDivider";

const DividerContainer = () => {
  return (
    <Fragment>
      <Breadcrumbs mainTitle={Divider} parent={UIKits} />
      <Container fluid>
        <Row>
          <HorizontalSolidDivider />
          <HorizontalDashedDivider />
          <HorizontalDottedDivider />
          <VerticalSolidDivider />
          <VerticalDottedDivider />
          <VerticalDoubleDivider />
          <AnimatedColorDivider />
          <HorizontalEditableDivider />
          <SimpleHorizontalDivider />
          <SimpleVerticalDivider />
        </Row>
      </Container>
    </Fragment>
  );
};

export default DividerContainer;
